"use es6";

import { DeferObservable } from './DeferObservable';
export const defer = DeferObservable.create;